module.exports = __webpack_public_path__ + "img/130.161d4f3f.png";